import * as React from 'react';
import { Button, ButtonStyle, IButtonProps } from './Button';
import { Classes, CloseButtonMode } from '../index';
import classNames from 'classnames';
type NavbarProps = Omit<IButtonProps, 'danger' | 'inverse' | 'style'> & {
  style?: Exclude<ButtonStyle, 'primary'>;
  mode?: CloseButtonMode;
};
export const CloseButton: React.FC<NavbarProps> = ({
  children,
  className,
  mode = 'edit',
  ...props
}) => {
  let textContent = '';
  switch (mode) {
    case 'view':
      textContent = 'Zavřít';
      break;
    case 'edit':
      textContent = 'Zrušit';
      break;
  }
  return (
    <Button
      dataTest={'close'}
      style={'none'}
      {...props}
      className={classNames(className, Classes.BUTTON_CLOSE)}
    >
      {children ? children : textContent}
    </Button>
  );
};
